/* eslint-disable */


const singleEvent = document.querySelector('body.single-tribe_events');

if (singleEvent) {
  const mapWrapper = document.querySelector('.wrapper-map');
  const singleEventDescription = document.querySelector('.single-event-description');
  const main = document.querySelector('.single-tribe_events .main');
  
  const eventTopWrapper = document.querySelector('.event-top');
  const movingElement = document.querySelector('.event-top .right');
  const initialPosition = document.querySelector('.event-top .left');
  
  const mediaQuery = '(max-width: 991px)';
  const mediaQueryList = window.matchMedia(mediaQuery);
  
  
  if(mediaQueryList.matches) {
    singleEventDescription.insertAdjacentElement('afterend', mapWrapper);
    eventTopWrapper.insertAdjacentElement('afterbegin', movingElement);
  } else {
    main.prepend(mapWrapper);
    initialPosition.insertAdjacentElement('afterend', movingElement);
  }
  
  mediaQueryList.addEventListener('change', event => {
    if (event.matches) {
      console.log('less than 991px');
      singleEventDescription.insertAdjacentElement('afterend', mapWrapper);
      eventTopWrapper.insertAdjacentElement('afterbegin', movingElement);
    } else {
      console.log('more than 991px');
      main.prepend(mapWrapper);
      initialPosition.insertAdjacentElement('afterend', movingElement);
    }
  })
}




// WEBPACK FOOTER //
// ./scripts/single-event.js